<template>
  <div>
    <nav-bar/>
    <div class="row page-padding">
      <div class="col-12 pt-0">
        <div
            v-if="banner !== null && banner !== undefined && banner.length > 0 && isBannerLoaded"
            class="row "
            dir="ltr">
          <carousel
              :autoplay="true"
              :dots="false"
              :items="1"
              :loop="false"
              :margin="5"
              :nav="false"
              :rtl="true"
              class="col-12 py-0 ">
            <div
                v-for="item in banner"
                :key="item.BannerId"
            >
              <v-img
                  v-if="item.FileUrl !== null"
                  :src="$replaceHttps(item.FileUrl)"
                  @click="$openLink(item.Link)">
              </v-img>
            </div>
          </carousel>
        </div>
      </div>
    </div>


    <div class="container">
      <div class="row">
        <div v-for="item in ticketingCards" :key="item.id" class="col-md-4 col-12">
            <v-card class="py-7 px-3 zoom">
              <div class="text-center">
                <img :src="getImgUrl(item.src)" height="200"/>
                <div class="font-weight-bold font17px mt-4">{{ item.title }}</div>
                <div class="mt-5">{{ item.desc }}</div>
                <div class="mt-7">
                  <v-btn @click="sendTicketClick(item.targetId)" outlined large color="primary" class="cards-btn">
                    {{ item.btnText }}
                  </v-btn>
                </div>
              </div>
            </v-card>
        </div>
      </div>
    </div>


    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";
import carousel from "vue-owl-carousel";



export default {
  name: "HomePage",
  components: { NavBar, carousel},
  metaInfo() {
    return {
      title: 'تیکتینگ-خانه '
    }
  },
  data: () => ({
    isBannerLoaded: false,
    banner: [],
    ticketingCards: [
      {
        id: 1,
        title: 'ارسال تیکت',
        desc: 'شما میتوانید با استفاده از ارسال تیکت از کارشناسان ما کمک بکیرید.',
        path: 'sendTicket',
        icon: 'fad fa-pencil',
        src: 'ticketing1.jpg',
        btnText: 'ارسال تیکت',
        targetId: 'sendTicket'
      },
      {
        id: 2,
        title: 'پایگاه دانش',
        desc: 'شما باید جهت دسترسی و مدیریت تیکت های خود وارد سایت شوید.',
        path: 'knowledgeBaseClient',
        icon: 'fad fa-bars',
        src: 'ticketing2.jpg',
        btnText: 'مشاهده بیشتر',
        targetId: 'knowledgeBaseClient'
      },
      {
        id: 3,
        title: 'جستجوی تیکت ها',
        desc: 'شما باید به منظور انجام جستجو در تیکت های خود،وارد سایت شوید.',
        path: 'searchTickets',
        icon: 'fad fa-search',
        src: 'ticketing3.jpg',
        btnText: 'جستجو',
        targetId: 'listTickets'

      },
    ],
    showLoaderDialog: true
  }),
  mounted() {

    this.getBanners()
    let _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/)
    if (_iOSDevice) {
      this.$addToHomescreen.mount({
        lang: "en_GB",
        buttonColor: "#006aff",
        title: 'وب اپلیکیشن سامانه پشتیبانی ایران زیلو',
        iconPath: 'https://Pwa.asiagroup.click/img/icons/favicon.ico',
        content: 'وب اپلیکیشن سامانه پشتیبانی ایران زیلو را به صفحه اصلی موبایل خود اضافه کنید'
      });
    }
  },
  methods: {
    sendTicketClick(targetId){
      let elem = document.getElementById(targetId);
      elem.click();
    },
    getImgUrl(pic) {
      return require('../../assets/img/' + pic)
    },
    getBanners() {
      this.showLoaderDialog = true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetBanners", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.showLoaderDialog = false
            if (json.length > 0) {
              this.banner = JSON.parse(result).filter(x => x.IsActive === true && x.FileUrl !== null);
            }
            this.isBannerLoaded = true
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>